
/**
 * Standardized validation messages to ensure consistency across the application
 */

export class ValidationMessages {
  static required = "This field is required";
  static email = "Please enter a valid email address";
  static phone = "Please enter a valid phone number";
  static url = "Please enter a valid URL";
  static match = "Fields do not match";
  static minLength = "Input is too short";
  static maxLength = "Input is too long";
  static password = "Password must be at least 8 characters with uppercase, lowercase, number, and special character";
  static date = "Please enter a valid date";
  static futureDate = "Date must be in the future";
  static pastDate = "Date must be in the past";
  static fileSize = "File size is too large";
  static fileType = "File type is not supported";
  static alphabetsOnly = "Only letters are allowed";
  static numbersOnly = "Only numbers are allowed";
  static decimalNumber = "Please enter a valid number";
  static positiveNumber = "Please enter a positive number";
  static validPercentage = "Please enter a valid percentage (0-100)";
  static zipCode = "Please enter a valid postal code";
}

// Dynamic message functions
export const getMinLengthMessage = (min: number): string => {
  return `Must be at least ${min} characters`;
};

export const getMaxLengthMessage = (max: number): string => {
  return `Cannot exceed ${max} characters`;
};

export const getRangeMessage = (min: number, max: number): string => {
  return `Must be between ${min} and ${max}`;
};

export const getFileSizeMessage = (maxSize: number): string => {
  const sizeInMB = maxSize / (1024 * 1024);
  return `File size must be less than ${sizeInMB.toFixed(2)} MB`;
};
